import axios from "axios";
import auth from "@/stores/auth"

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:8000/api/v1",
  timeout: 10000,
});

api.interceptors.request.use(
  (config) => {
    const token = auth.state.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      auth.logout()
    }
    return Promise.reject(error)
  }
)


export async function getApi(endpoint, params = {}) {
  try {
    const response = await api.get(endpoint, { params });
    return response.data;
  } catch (error) {
    console.error(`GET ${endpoint} hatası:`, error);

    if (error.response && error.response.status === 404) {
      console.warn(`GET ${endpoint} 404`);
      return [];
    }

    throw error;
  }
}

export async function postApi(endpoint, data = {}, config = {}) {
  try {
    const response = await api.post(endpoint, data, config);
    return response.data;
  } catch (error) {
    console.error(`POST ${endpoint} hatası:`, error);

    if (error.response && error.response.status === 404) {
      console.warn(`POST ${endpoint} 404`);
      return {};
    }

    throw error;
  }
}

export async function putApi(endpoint, data = {}) {
  try {
    const response = await api.put(endpoint, data);
    return response.data;
  } catch (error) {
    console.error(`PUT ${endpoint} hatası:`, error);

    if (error.response && error.response.status === 404) {
      console.warn(`PUT ${endpoint} 404`);
      return {};
    }

    throw error;
  }
}

export async function deleteApi(endpoint) {
  try {
    const response = await api.delete(endpoint);
    return response.data;
  } catch (error) {
    console.error(`DELETE ${endpoint} hatası:`, error);

    if (error.response && error.response.status === 404) {
      console.warn(`DELETE ${endpoint} 404`);
      return { success: true };
    }

    throw error;
  }
}

export default api;
